import { theme } from '@fiverr-private/theme';

export const ANIMATION_DURATION = theme.numericAnimationDurations.moderate3;
